// extracted by mini-css-extract-plugin
export default {"checkbox-wrapper":"checkbox-wrapper---SP2Bd","checkbox-with-asterisk":"checkbox-with-asterisk---jrWQl"};